var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container page-terms"},[_c('div',{staticClass:"h2 page-title"},[_vm._v("Termos de uso do sistema Stenci")]),_c('terms-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }